import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const palindromeBadgeDefinition: BoggleBadgeDefinition = {
  category: 'letters',
  description:
    'Play a word of length 5+ that reads the same backward and forward',
  iconId: 'palindrome',
  id: 'palindrome',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Palindrome',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
